
import React from 'react';
import { FacilityOrderTemplateNewFlowUSIntakePortalNoteModalTemplate } from 'themes/application/facility-order-new-flow-us-intake/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderTemplateNewFlowUSIntakePortalNoteModalStore } from 'application/facility-order-new-flow-us-intake/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderTemplateNewFlowUSIntakePortalNoteModalStore(rootStore, componentProps), 'facilityOrderTemplateNewFlowUSIntakePortalNoteModalStore')
@observer
class FacilityOrderTemplateNewFlowUSIntakePortalNoteModal extends React.Component {
    render() {
        return <FacilityOrderTemplateNewFlowUSIntakePortalNoteModalTemplate {...this.props} />
    }
}

export default FacilityOrderTemplateNewFlowUSIntakePortalNoteModal;
